import Icon from '../components/Icon.vue'

Icon.register({"star-half":{"width":896,"height":1792,"paths":[{"d":"M832 32v1339l-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half.js
// module id = 1852
// module chunks = 0